<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Servicios Pendientes de Radicación
                    <div class="float-right">
                      <!-- <b-button
                        variant="primary"
                        @click="updateGlobal({state: 'openModal/modal/modal',data: 'Grupal'});updateGlobal({state: 'openModal/modal/value',data: true });updateGlobal({state: 'openModal/modal/title',data: 'Guardado Grupal' })"
                      >Guardado Grupal</b-button> -->
                    </div>
                  </div> 
                </template> 
                <sw-tableget 
                    :warningClass="warningClass"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_aflpendientes"
                    :dataRoute="{others: []}"
                    @filtrar="getFiltrar"
                    @limpiar="getLimpiar"
                    @save="saveForm"
                    > 
                    <template v-slot:filtrar>
                      <b-row  style="margin-bottom:5px;padding-top:15px;border: 1px ridge;background: #fafafa">
                        <b-col class="d-none d-md-block" :md="6">                          
                          <b-input-group class="filter-sw-group" size="sm" prepend="Seleccionar servicios" >
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                              v-model="filter.name"                   
                              :options="dataMultiple[namePath].multiple_servicios"
                              label="name"
                              track-by="name"
                              :clear-on-select="false"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              @input="filter.id_list=null"
                              >
                              </c-multiselect>
                          </b-input-group>                         
                        </b-col>
                        <b-col class="d-none d-md-block" :md="6" v-if="filter.name!=null">                          
                          <b-input-group class="filter-sw-group" size="sm" :prepend="'Entidad '+filter.name.name" >
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                              v-model="filter.id_list"                   
                              :options="entidades"
                              label="name"
                              track-by="name"
                              :clear-on-select="false"
                              :preselect-first="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group>                         
                        </b-col>
                        <b-col class="d-md-none" :cols="12"> 
                          <b-form-group
                            class="mb-0"
                            label="Seleccionar servicios"
                          >                
                          <c-multiselect
                              style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                              v-model="filter.name"                   
                              :options="dataMultiple[namePath].multiple_servicios"
                              label="name"
                              track-by="name"
                              :clear-on-select="false"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                          </c-multiselect>
                          </b-form-group>                    
                        </b-col>
                      </b-row>                      
                    </template>   

                    <template v-slot:modal>
                      <sw-modalficha 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm">
                      </sw-modalficha>
                    </template> 
                </sw-tableget>
                <br> 
                <p v-if="dataGet[namePath].data.length===0 && !awaitDataGet" class="text-center" style="padding-left:20px;padding-bottom:10px">Buen trabajo, no tienes ningún pendiente por radicar.</p>
            </b-card>  
      </b-col>      
    </b-row>  
    <!-- <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="xl" 
      >        
        <SwModalPendienteGrupal
          v-if="openModal.modal.modal==='Grupal'"
          @save="saveForm"                     
          />
    </b-modal>  -->
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalficha from '@/components/modals/ficha.vue'
import SwModalanularafiliacion from '@/components/modals/anularAfiliacion.vue'
import SwModalPendienteGrupal from '@/components/modals/Afiliacion/Pendientes/grupal.vue'
import PhotoEditor from '@/components/photo-editor/loader.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afl_pendientes",
  components: { 
    SwTableget,
    SwModalficha,
    'c-multiselect': Multiselect,
    SwModalanularafiliacion,
    PhotoEditor,
    SwModalPendienteGrupal
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],

};
</script>
<style >
.filter-sw-group .input-group-text{
  max-height: 34px !important;
}
.filter-sw-group .multiselect__tags{
  height: 34px;
}
.filter-sw-group .multiselect__placeholder{
  padding-top: 4px;
  padding-left: 4px;
}
.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>


